import Modal from "../shared/Modal";
import "./ModalNoResources.css";

type ModalNoResourcesProps = {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
};

const ModalNoResources = ({
  isOpen,
  onClose,
  onContinue,
}: ModalNoResourcesProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        style={null}
        onClose={onClose}
        canClose={false}
        allowClickout={true}>
        <div id="modal-no-resources-google-verify">
          <div className="modal-no-resources-google-verify-title">
            Please Add Resources
          </div>

          <div className="modal-no-resources-google-verify-content">
            You have not added any resources so there is no documentation to run
            your report card against.
          </div>

          <div className="modal-no-resources-google-verify-footer">
            <div className="modal-no-resources-google-verify-buttons">
              <button onClick={onClose} className="collections-button-negative">
                Cancel
              </button>
              <button
                onClick={() => onContinue()}
                className="collections-button">
                Add Resources
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalNoResources;
